import Breadcrumbs from 'Components/Breadcrumbs'
import CustomButton from 'Components/CustomButton'
import ListActions from 'Components/ListActions'
import PageTitle from 'Components/PageTitle'
import TicketSaleDrawer from 'Services/SalesManagement/Features/TicketSale/Components/TicketSaleDrawer'
import TicketSaleList from 'Services/SalesManagement/Features/TicketSale/Components/TicketSaleList/TicketSaleList'
import useTicketSalesWithParams from 'Services/SalesManagement/Features/TicketSale/Hooks/useTicketSalesWithParams'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import AddIcon from '@mui/icons-material/Add'
import { Box } from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { t } from 'ttag'

export default function TicketSaleListPage() {
  const navigate = useNavigate()
  const baseUrl = `${SALES_MANAGEMENT_ROOT_URL}/ticket-sales/qr-group-ticket-sales`
  const title = t`QR group ticket sales`
  const breadcrumbs = [
    {
      title: t`Home`,
      link: SALES_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Ticket sales`
    },
    {
      title: title
    }
  ]

  const { data, isFetching, params, setParams, selectedTicketSaleId, setSelectedTicketSaleId } =
    useTicketSalesWithParams()
  const [isDrawerOpen, setIsDrawerOpen] = useState(!!selectedTicketSaleId)

  const handleRequestSort = (_event: React.MouseEvent<unknown>, property: string) => {
    const isAsc = params.ordering.includes('-')
    setParams(prevState => ({ ...prevState, ordering: `${isAsc ? '' : '-'}${property}` }))
  }

  const handleChangePage = (_event: unknown, newPage: number) => {
    setParams(prevState => ({ ...prevState, page: newPage + 1 }))
  }

  const handleRowClick = (id: string) => {
    setSelectedTicketSaleId(id)
    setIsDrawerOpen(true)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 2 }}>
        <Breadcrumbs items={breadcrumbs} />
        <PageTitle>{title}</PageTitle>
      </Box>
      <ListActions>
        <CustomButton
          onClick={() => navigate(`${baseUrl}/create`)}
          size="small"
          startIcon={<AddIcon />}
        >
          {t`Sell new QR group ticket`}
        </CustomButton>
      </ListActions>
      <Box pt={1}>
        <TicketSaleList
          rows={data?.results ?? []}
          isLoading={isFetching}
          params={params}
          handleRequestSort={handleRequestSort}
          handleChangePage={handleChangePage}
          count={data?.count ?? 0}
          page={params.page - 1}
          onRowClick={handleRowClick}
          selectedTicketSaleId={selectedTicketSaleId}
        />
      </Box>
      <TicketSaleDrawer
        open={isDrawerOpen}
        handleClose={() => {
          setIsDrawerOpen(false)
          setSelectedTicketSaleId('')
        }}
        selectedTicketSaleId={selectedTicketSaleId}
      />
    </Box>
  )
}
